import { render, staticRenderFns } from "./moreHTFTCS.vue?vue&type=template&id=2c6b33d4&lang=pug&"
import script from "./moreHTFTCS.vue?vue&type=script&lang=js&"
export * from "./moreHTFTCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports